// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3igvU","footer":"styles_footer__3fUU8"};